export const DEVICE_CACHE_TTL_MS = 3 * 24 * 60 * 60 * 1000;

export const SUBMIT_DEVICE_WAIT_MS = 3000;

const SUBMIT_FRESH_KEYS = ['markers', 'markerGlobal', 'automation', 'params', 'url'];

const SUBMIT_FRESH_SOURCES = SUBMIT_FRESH_KEYS.filter((key) => key !== 'params' && key !== 'url');

function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(36);
}

function sortedEntries(options) {
  const o = options && typeof options === 'object' ? options : {};
  return Object.keys(o)
    .sort()
    .map((key) => [key, o[key]]);
}

export const DEVICE_CACHE_KEY_PREFIX = '__rs_device_';

export function deviceCacheKey(parts) {
  return (
    DEVICE_CACHE_KEY_PREFIX +
    fnv1a(JSON.stringify([parts.appId, !!parts.fp, !!parts.di, sortedEntries(parts.fpOptions)]))
  );
}

export function deviceCacheTag(parts) {
  return fnv1a(
    JSON.stringify([
      parts.appId,
      parts.version,
      !!parts.fp,
      !!parts.di,
      sortedEntries(parts.fpOptions),
      parts.userAgent,
      parts.sessionId,
    ])
  );
}

const TIMING_SENT_MARK = 't';

export function encodeDeviceRecord(record) {
  const parts = [record.savedAt.toString(36), record.tag, record.payload];
  if (record.timingSent) parts.push(TIMING_SENT_MARK);
  return parts.join('.');
}

export function decodeDeviceRecord(raw) {
  if (typeof raw !== 'string') return null;
  const parts = raw.split('.');
  if (parts.length !== 3 && !(parts.length === 4 && parts[3] === TIMING_SENT_MARK)) return null;
  const savedAt = parseInt(parts[0], 36);
  if (!Number.isFinite(savedAt) || !parts[1] || !parts[2]) return null;
  return { savedAt, tag: parts[1], payload: parts[2], timingSent: parts.length === 4 };
}

export function isDeviceRecordFresh(record, tag, now) {
  if (!record || record.tag !== tag) return false;
  const age = now - record.savedAt;
  return age >= 0 && age < DEVICE_CACHE_TTL_MS;
}

function isFreshIncident(incident) {
  return !!incident && SUBMIT_FRESH_SOURCES.indexOf(incident.source) !== -1;
}

function withoutKeys(obj, keys) {
  const out = {};
  const objKeys = Object.keys(obj);
  for (let i = 0; i < objKeys.length; i++) {
    if (keys.indexOf(objKeys[i]) === -1) out[objKeys[i]] = obj[objKeys[i]];
  }
  return out;
}

function storedIncidents(incidents) {
  return (Array.isArray(incidents) ? incidents : []).filter((incident) => !isFreshIncident(incident));
}

export function isCleanCollect(data, options) {
  const incidents = Array.isArray(data.incidents) ? data.incidents : [];
  const storageProbe = data.timing ? data.timing.storageProbe : undefined;
  const storageTimeoutOk = !!(options && options.storageTimeoutOk);
  return (
    incidents.every(isFreshIncident) && storageProbe !== 'error' && (storageProbe !== 'timeout' || storageTimeoutOk)
  );
}

export function deviceDataForStore(data) {
  const out = withoutKeys(data, SUBMIT_FRESH_KEYS);
  out.incidents = storedIncidents(data.incidents);
  return out;
}

export function mergeSubmitData(stored, fresh, meta) {
  const out = withoutKeys(stored, SUBMIT_FRESH_KEYS);
  for (let i = 0; i < SUBMIT_FRESH_KEYS.length; i++) {
    const key = SUBMIT_FRESH_KEYS[i];
    if (fresh[key] !== undefined) out[key] = fresh[key];
  }
  out.incidents = storedIncidents(stored.incidents).concat(Array.isArray(fresh.incidents) ? fresh.incidents : []);
  out.timing = Object.assign({}, stored.timing, {
    cacheHit: meta.cacheHit,
    cacheAgeMs: meta.ageMs,
    submit: fresh.timing,
  });
  return out;
}
